import JobFormPage from './JobFormPage';

export default JobFormPage;